// extracted by mini-css-extract-plugin
export default {"component":"loader_component__Nu42O","line":"loader_line__CR6r4"};